import { Component, OnInit, PipeTransform, Pipe, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeHtml, SafeStyle, SafeScript, SafeUrl, SafeResourceUrl } from '@angular/platform-browser';
import { HostListener } from "@angular/core";
import { Location } from '@angular/common'
import Game from '../../data/gamesData.json';
import { environment } from 'src/environments/environment';
import { ContentServiceService } from 'src/app/service/content-service.service';
import { NavigationService } from 'src/app/service/navigation.service';


@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }
  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
@Component({
  selector: 'app-game-play',
  templateUrl: './game-play.component.html',
  styleUrls: ['./game-play.component.css']
})
export class GamePlayComponent implements OnInit {
  public games = Game;
  gameId: any;
  gameData: any;
  gameUrl: any
  scrHeight: any;
  scrWidth: any;
  allGamesData: any;
  source: string = 'portal';
  showModalBox: boolean = false;
  page: string;

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.scrHeight = window.innerHeight;
    this.scrWidth = window.innerWidth;
    console.log(this.scrHeight);
  }


  constructor(private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private location: Location,
    private contentService: ContentServiceService,
    private navigationService: NavigationService) { }

  ngOnInit(): void {
    this.source = sessionStorage.getItem('source') ? sessionStorage.getItem('source') : 'portal';
    if (this.source == 'SIGADS') {
      this.showModal()
    } else {
      this.gameId = this._activatedRoute.snapshot.paramMap.get('id');
      this.page = this._activatedRoute.snapshot.paramMap.get('page');
      console.log('this.category', this.gameId);
      this.getScreenSize();
      //this.getAllGamesData();
      if (sessionStorage.getItem('isSubscribed') == '1') {
        this.getgameData(this.gameId)
      } else {
        this._router.navigateByUrl('/lp')
      }
    }
  }

  getgameData(gameId) {

    let endpoint = "gameContent/gameContent";
    let data = {
      "data": {
        "gameid": gameId,
      }
    }

    this.contentService.getGameContentById(data, endpoint)
      .then(response => {
        if (response['success']) {
          console.log("Success..", response)
          this.gameUrl = response['data'][0]['url'];
          console.log("gameData URL", this.gameUrl);
        }
      })
      .catch(error => {
        console.log("Error", error);
        //this._router.navigate(['/content-management/portal'])
      })
  }



  showModal() {
    console.log("click");
    this.showModalBox = true
  }
  closeModal() {
    console.log("click");

    this._router.navigateByUrl('/lp')
    this.showModalBox = false;
  }

  back() {
    this._router.navigateByUrl('/' + this.page)
    // this.location.back()
    //this.navigationService.back(page);
  }
}
